










































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {cloneDeep, isEqual} from "lodash"
import {v4 as uuidv4} from 'uuid'
import draggable from 'vuedraggable'
import SurveyQuestion from "@/components/beta/Settings/Surveys/SurveyQuestion.vue";
import DetailSideBar from '@/components/beta/Settings/Surveys/DetailSideBar.vue'
import Modal from '@/components/UI/Modal.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import IPencil from '@/components/icons/IPencil.vue'
import ICheck from '@/components/icons/ICheckContactBlock.vue'
import IClose from '@/components/icons/IClose.vue'
import IBack from '@/components/icons/IBack.vue'
import ICopy from '@/components/icons/ICopy.vue'
import IInfo from '@/components/icons/IInfo.vue'
import ISave from '@/components/icons/ISave.vue'
import IRestore from '@/components/icons/IRestore.vue'

const surveys = namespace('surveys')
const dialog = namespace('dialog')
const forms = namespace('forms')
const workspace = namespace('workspace')

@Component({
  name: "Survey",
  components: {
    draggable,
    SurveyQuestion,
    DetailSideBar,
    Modal,
    Tooltip,
    BtnDefault,
    IPencil,
    ICheck,
    IClose,
    IBack,
    ICopy,
    IInfo,
    ISave,
    IRestore,
  }
})
export default class Survey extends Vue {
  @surveys.Action('showEditAlert') protected showEditAlert: any
  @surveys.Getter('survey') protected survey: any
  @surveys.Action('editSurvey') protected editSurveyFromServer: any
  @surveys.Action('editSurveyTitle') protected editSurveyTitle: any
  @surveys.Action('changeActiveFalse') protected changeActiveFalse: any
  @surveys.Action('createSurvey') protected createSurvey: any
  @surveys.Mutation('setSurvey') protected setSurvey: any
  @surveys.Mutation('setIsNotChange') protected setIsNotChange: any


  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetSubtitleDialog') protected SetSubtitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any
  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @forms.Mutation('setOptions') protected setOptions: any
  @workspace.Getter('getPlan') protected getPlan: any

  questions: any = []
  currentQuestions: any = []
  deletedQuestion: any = []
  deletedAnswer: any = []


  currentSurvey: any = []

  notChange: boolean = false
  isChangeQuestion: boolean = false

  currentComposedQuestion: any = []
  composedQuestions: any = []
  decomposedQuestions: any = []

  drag: boolean = false
  isShowChangeActive: boolean = false
  isEditTitle: boolean = false
  isActive: boolean = false
  title: string = ''
  countShards: number = 0
  signature: any = {}
  modal: any = {
    deleteQuestion: false,
    deleteAnswer: false,
    isCurrent: false,
    isChange: false,
    isError: false
  }
  isCurrent: boolean = false
  currentQuestion: any = {}

  get titleSurvey() {
    return this.$t('toolbar.surveys')
  }

  get isNotChange() {

    let isChange =isEqual(this.survey.questions, this.currentSurvey.questions)
    // || this.notChange
    // || !this.currentQuestions
    // || !this.composedQuestions

    this.setIsNotChange(isChange)
    return isChange
  }

  get hasSignature() {
    return this.signature.order !== undefined
  }

  get deleteQuestionTitle() {
    return this.deletedQuestion.type != 'text_container' ? this.$t('surveys.modal.deleteQuestion.title.question') :
        this.deletedQuestion.order == '777777777' ? this.$t('surveys.modal.deleteQuestion.title.signature') :
            this.$t('surveys.modal.deleteQuestion.title.comment')
  }

  @Watch('fullDialogShow')
  setQuestion() {
    if (!this.fullDialogShow) {
      this.composeQuestions(this.survey.questions)
    }
  }

  beforeMount() {
    window.addEventListener('beforeunload', (event) => {
      if (this.isNotChange) return

      event.preventDefault()
      event.returnValue = ''
    })
  }

  async mounted() {
    this.composeQuestions(this.survey.questions)
    this.currentComposedQuestion = cloneDeep(this.composedQuestions)
    this.countShards = this.survey.countOfShards
    this.currentSurvey = cloneDeep(this.survey)
  }

  destroyed() {
    window.removeEventListener('beforeunload', (event) => {

    })
  }

  nextPage() {
    this.modal.isChange = false
    this.survey.isEdit = false
    this.notChange = true
    this.currentSurvey = cloneDeep(this.survey)
    this.composeQuestions(this.survey.questions)
    this.$emit('showSurveys')
  }

  composeQuestions(questions: any) {
    this.composedQuestions = []
    this.resetQuestions(questions)
    questions.forEach((question: any, index: number) => {
      if (question.order != '777777777') {
        this.checkQuestion(question, 0, index)
        question.order = ++index
      } else {
        this.signature = question
        this.signature.id = uuidv4()
      }
      question.answers.forEach((answer: any) => {
        answer.isEdit = false
      })
    })
    questions.forEach((question: any) => {
      if (!question.include && question.order != '777777777') this.composedQuestions.push(question)
    })
  }

  resetQuestions(questions: any) {
    questions.forEach((question: any) => {
      question.count = 0
      question.include = false
    })
  }

  checkQuestion(question: any, count: number, questionIndex: number = 0) {
    if (question.count === undefined) {
      question.count = count
    } else if (count > question.count) {
      question.count = count
    }
    if (!question.id) {
      question.id = uuidv4()
    }
    question.answers.forEach((answer: any) => {
      answer.includeQuestions.forEach((includeQuestion: any, index: number) => {
        let currentQuestion = this.survey.questions.filter((q: any) => {
          return q.id == includeQuestion || q.id == includeQuestion.id
        })
        if (currentQuestion.length) {
          this.checkQuestion(currentQuestion[0], count + 1)
          currentQuestion[0].include = true
          answer.includeQuestions[index] = currentQuestion[0]
        }
      })
    })
  }

  editSurveyOpenModal() {

    if (this.isCurrent) {
      this.modal.isCurrent = true
    } else {
      this.editSurvey()
    }

  }

  changeActive(item: any) {
    this.changeActiveFalse({
      params: {
        surveyCode: item._id,
      },
      body: {
        isActive: false
      }
    })
  }
  async changeActiveTrue() {
    await this.changeActiveFalse({
      params: {
        surveyCode: this.survey._id,
      },
      body: {
        isActive: true
      }
    })
    this.isShowChangeActive = false
    this.survey.isEdit = false
    this.notChange = true
    this.modal.isCurrent = false
  }

  editSurvey() {
    this.currentSurvey = cloneDeep(this.survey)
    if (this.survey.isActive) {
      this.changeActive(this.currentSurvey)
    }
    this.survey.isEdit = true
    this.notChange = false
    this.modal.isCurrent = false

    this.showEditAlert(this.$t('tooltip.surveys.isNotAccess'))


  }

  changeQuestion() {
    this.composeQuestions(this.survey.questions)
    this.isChangeQuestion = !this.isChangeQuestion
  }

  changeOrder() {
    this.getQuestionsForSave()
    this.survey.questions = this.currentQuestions
    this.composeQuestions(this.survey.questions)
  }

  addQuestion() {
    this.setOptions({
      id: this.survey.id
    })
    this.SetTitleDialog(this.$t('surveys.dialog.addQuestion'))
    this.SetSubtitleDialog('')
    this.SetFormSDialog('AddQuestionForm')
    this.SetFullDialogShow(true)
  }

  addSignature() {
    this.setOptions({
      id: this.survey.id
    })
    this.SetTitleDialog(this.$t('surveys.dialog.addSignature'))
    this.SetFormSDialog('AddSignatureForm')
    this.SetFullDialogShow(true)
  }

  addComment() {
    this.setOptions({
      id: this.survey.id
    })
    this.SetTitleDialog(this.$t('surveys.dialog.addComment'))
    this.SetFormSDialog('AddComentForm')
    this.SetFullDialogShow(true)
  }

//   /* Question */

  openModalDeleteQuestion(question: any) {
    this.modal.deleteQuestion = true
    this.deletedQuestion = {...question}
  }

  deleteQuestion() {
    this.modal.deleteQuestion = false
    if (this.deletedQuestion.order == '777777777') {
      this.signature = {}
    }
    this.survey.questions = this.survey.questions.filter((question: any) => {
      return question.id != this.deletedQuestion.id
    })
    this.composeQuestions(this.survey.questions)
    this.isActive = false
  }

  addAnswers(question: any) {
    this.setOptions(question)
    this.SetTitleDialog(this.$t('surveys.dialog.addAnswers'))
    this.SetFormSDialog('AddAnswersForm')
    this.SetFullDialogShow(true)
  }


  openModalDeleteAnswer(question: any, answer: any) {
    this.modal.deleteAnswer = true
    this.deletedAnswer = {...answer}
    this.deletedQuestion = {...question}
  }

  deleteAnswer() {
    this.modal.deleteAnswer = false
    this.survey.questions.map((q: any) => {
      if (q.id == this.deletedQuestion.id) {
        q.answers = q.answers.filter((a: any) => {
          return a.id != this.deletedAnswer.id
        })
      }
      return q
    })
    this.composeQuestions(this.survey.questions)
  }

  editAnswer(answer: any, question: any) {
    this.composedQuestions.forEach((question: any) => {
      question.answers.forEach((answer: any) => {
        answer.isEdit = false
      })
    })
    answer.isEdit = true
    this.isChangeQuestion = !this.isChangeQuestion
  }

  changeAnswer(answer: any, currentAnswer: any) {
    this.isChangeQuestion = !this.isChangeQuestion
    answer.isEdit = false
    answer.value = currentAnswer.value
  }

  cancelEditAnswer(answer: any) {
    answer.isEdit = false
    this.isChangeQuestion = !this.isChangeQuestion
  }

  chooseQuestion(question: any) {
    this.isActive = this.currentQuestion.id != question.id
    if (this.currentQuestion.id == question.id) {

    }
    if (this.survey.isEdit) {
      this.questions.map((q: any) => {
        if (question.id != q.id) {
          q.active = false
        } else {
          q.active = !q.active
        }
      })
      if (this.isActive) {
        this.currentQuestion = question
      } else {
        this.currentQuestion = []
      }
    }
  }

  changeIncludes(answer: any, title: string, question: any) {
    this.currentQuestions = []
    let questions = cloneDeep(this.composedQuestions)
    this.decomposeQuestions(questions)
    this.setOptions({
      questions: this.currentQuestions,
      answer: answer,
      currentQuestion: question
    })
    this.SetSubtitleDialog(title)
    this.SetTitleDialog(answer.value)
    this.SetFormSDialog('ChangeIncludeQuestionForm')
    this.SetFullDialogShow(true)
  }

  deleteIncludeQuestion(answer: any, includeQuestion: any) {
    answer.includeQuestions = answer.includeQuestions.filter((q: any) => q.id != includeQuestion.id)
    includeQuestion.count = 0
    this.questions.push(includeQuestion)
    this.composeQuestions(this.survey.questions)
  }

  back() {
    if (!this.isNotChange && this.survey.isEdit) {
      this.modal.isChange = true
    } else {
      this.$emit('showSurveys')
    }
  }

  async changeArchive() {
    await this.editSurveyFromServer({
      params: {
        surveyCode: this.survey._id,
      },
      body: {
        isArchived: false
      }
    })
  }

  editTitle() {
    this.isEditTitle = true
    this.title = this.survey.title
  }

  decomposeQuestions(questions: any) {
    questions.forEach((question: any) => {
      if (typeof (question) != 'string') {
        question.include = false
        delete question.count
        if (this.currentQuestions.filter((el: any) => {
          return el.id == question.id
        }).length == 0) {
          this.currentQuestions.push(question)
          question.answers.forEach((answer: any) => {
            this.decomposeQuestions(answer.includeQuestions)
            let questions: any = []
            answer.includeQuestions.forEach((includeQuestion: any) => {
              questions.push(includeQuestion.id)
            })
            answer.includeQuestions = questions
          })
        }

      }
    })
  }

  async copy() {
    this.modal.isError = false
    this.getQuestionsForSave()
    await this.createSurvey({
      params: {
        CompanyCode: this.$route.params.code,
        showCode: this.$route.params.showCode,
      },
      body: {
        title: this.$t('surveys.copy') + ' ' + this.survey.title,
        questions: this.currentQuestions,
        hasSignature: this.survey.hasSignature,
        isArchived: false,
        isActive: false,
      }
    })
    this.countShards = this.survey.countOfShards
    this.composeQuestions(this.survey.questions)
    this.currentComposedQuestion = cloneDeep(this.composedQuestions)
  }

  async cancelEdit() {
    await this.setSurvey(this.currentSurvey)
    this.composeQuestions(this.survey.questions)
  }

  getQuestionsForSave() {
    this.currentQuestions = []
    let questions = cloneDeep(this.composedQuestions)
    this.decomposeQuestions(questions)
    this.currentQuestions.forEach((question: any, index: number) => {
      if (question.type == 'text_container') {
        question.specify = 'default'
      }
      delete question.answerTitle
      question.order = ++index
      question.active = false
      question.answers.forEach((answer: any, index: number) => {
        answer.order = ++index
        if (!answer.type || !answer.type.length) answer.type = 'regular'
      })
    })
    if (this.signature.order) this.currentQuestions.push(this.signature)
  }

  async saveSurvey() {
    this.getQuestionsForSave()
    let response = await this.editSurveyFromServer({
      params: {
        surveyCode: this.survey._id,
      },
      body: {
        title: this.survey.title,
        questions: this.currentQuestions,
        hasSignature: this.hasSignature
      }
    })
    if (response && response.response.data.error == 'has_answers_for_survey') {
      this.modal.isError = true
    }
    this.questions = []
    this.survey.questions.forEach((question: any, index: number) => {
      question.active = false
      if (question.order != '777777777') {
        //this.checkQuestion(question, 0, index)
      } else {
        this.signature = question
      }
    })
    this.survey.questions.forEach((question: any) => {
      if (!question.include && question.order != '777777777') this.questions.push(question)
    })
    this.isActive = false
    this.currentQuestion = []
    this.currentComposedQuestion = cloneDeep(this.composedQuestions)
    this.currentSurvey = cloneDeep(this.survey)
    this.composeQuestions(this.survey.questions)
    this.notChange = true
    this.setIsNotChange(true)
    if(!this.survey.isActive){
      this.isShowChangeActive = true
    }
  }

  async saveTitle() {
    this.survey.title = this.title
    this.isEditTitle = false
    let response = await this.editSurveyTitle({
      params: {
        surveyCode: this.survey._id,
      },
      body: {
        title: this.survey.title
      }
    })
  }

}
